import { call, put, takeLeading } from 'typed-redux-saga';

import DashboardGateway from '~apis/dashboard';
import combinedActions from '~redux/combinedActions';

import { store } from '~redux/store';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';

export default function* watchGetDashboardMarketStatus(api: DashboardGateway): SagaWatcherReturnType {
    yield takeLeading('dashboard/dashboardGetDashboardMarketStatusAttempt', handleGetDashboardMarketStatus, api);
}

function* handleGetDashboardMarketStatus(api: DashboardGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getDashboardMarketStatus], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.dashboardGetDashboardMarketStatusFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.dashboardGetDashboardMarketStatusSuccess(response.data));
    }
}
